import type { AxiosResponse } from 'axios'
import { apiClient } from '../client'
import { API_ENDPOINTS } from '@/config/api'
import { handleApiError } from '@/utils/apiErrorHandling'
import type { PrecinctsResponse } from '@/types/api/precinct'

class PrecinctService {
  async getPrecincts(): Promise<PrecinctsResponse> {
    try {
      const response: AxiosResponse<PrecinctsResponse> = await apiClient.get(
        API_ENDPOINTS.PRECINCTS
      )

      return response.data
    } catch (error) {
      throw handleApiError(error, 'getPrecincts')
    }
  }
}

export const precinctService = new PrecinctService()
export default precinctService
